/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class QuarantineIcon extends BaseIcon {
getChildren = () => [
        <path fill={ this.getColor() }
              d="M15,4V14a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V4A1,1,0,0,1,3,3H3.5a1.5,1.5,0,0,1,0-3h10a1.5,1.5,0,0,1,0,3H14A1,1,0,0,1,15,4ZM12,15h0ZM12,4H5A2,2,0,0,0,3,6v4A1.067,1.067,0,0,1,4,9c0.906,0,.531,1,2,1,1.144,0,1.125-1,2-1H9c0.781,0,.719,1,2,1s1.063-1,2-1a1.036,1.036,0,0,1,1,1v3h0V6A2,2,0,0,0,12,4Z"
              transform="translate(-0.5)"/>
    ]
    getViewBox = () => '0 0 16 16'
}
